import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { installCompatShims, installTranslationDomGuard } from './lib/browserCompat';
import { captureTranslationDomGuard } from './lib/sentry';

// Polyfill Array/String.prototype.at for legacy engines before any third-party
// script (e.g. PostHog's web-vitals extension) runs. See lib/browserCompat.ts
// and Sentry CODEPULSE-BACKEND-C4.
installCompatShims();

// Harden removeChild/insertBefore against browser auto-translation (Google
// Translate) reparenting text nodes under React, which otherwise crashes the
// commit phase. See lib/browserCompat.ts and Sentry CODEPULSE-BACKEND-CK. The
// guard is silent by design, so it reports each fallback to Sentry (info level,
// once per page load) to tell us whether translated sessions actually hit it.
installTranslationDomGuard(captureTranslationDomGuard);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
